module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/CardsVideo-382cc20da45a2e46a7b89f99445bbbdb.mp4";